<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    :largura="600"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center mt-1">
      <SysFilialGrupoAutocomplete
        v-model="filtros.filiais"
        label="Filiais"
        outlined
        hide-details
        multiple
        :qtde-visivel-selecionados="1"
      />
    </div>

    <div class="d-flex align-center">
      <div class="w-50-porcento pr-1">
        <SysSegmentoAutocomplete
          v-model="filtros.segmentos"
          label="Segmentos"
          outlined
          multiple
          hide-details
          class="mt-4"
        />
      </div>

      <div class="w-50-porcento pl-1">
        <SysSecaoAutocomplete
          v-model="filtros.secoes"
          label="Seções"
          outlined
          multiple
          hide-details
          class="mt-4"
        />
      </div>
    </div>

    <div class="d-flex align-center">
      <SysFornecedorAutocomplete
        v-model="filtros.fornecedores"
        label="Fornecedores"
        outlined
        multiple
        hide-details
        class="mt-4"
      />
    </div>
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete.vue";
import $axios from "@/api/api";

export default {
  name: "RelatorioAvariaProdutosFilialPorData",
  mixins: [Mixin],
  components: {
    SysSecaoAutocomplete,
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
  },
  data: () => ({
    filtros: {
      filiais: [],
      segmentos: [],
      secoes: [],
      fornecedores: [],
    },
  }),
  methods: {
    gerarRelatorio() {
      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
